import { useSelector } from 'react-redux'

export default function useTransactionListItemSelector(contributableType) {
  const transactionArray = useSelector(({ entities: { processedTransactions } }) => Object.values(processedTransactions))
  const trackedAccounts = useSelector(({ entities: { trackedAccounts } }) => trackedAccounts)
  const trackedAccountProviders = useSelector(({ entities: { trackedAccountProviders } }) => trackedAccountProviders)

  return (contributableId) => {
    const transaction = transactionArray.find((t) => t.contributableId === contributableId && t.contributableType === contributableType)
    const { date: transactionDate, amount: transactionAmount, name: transactionName, trackedAccountId } = transaction
    const { name: accountName, trackedAccountProviderId } = trackedAccounts[trackedAccountId]
    const { encodedBankLogo } = trackedAccountProviders[trackedAccountProviderId]
    return { encodedBankLogo, transactionName, accountName, transactionDate, transactionAmount }
  }
}
